@if (visible()) {
  <div style="margin-bottom: 1rem">
    <nz-row [id]="table.tableCode" [nzGutter]="[16, 16]">
      @for (record of visibleRecords(); track $index) {
        <nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
          <div class="cards-container">
            <div class="downloadCard">
              @if (record?.recordData?.documentRequired) {
                <div class="badge badge-required">Obligatorio</div>
              } @else {
                <div class="badge badge-optional">Opcional</div>
              }
              @if (record?.recordData?.documentComments) {
                <div class="backendMessage">
                  <button
                    nz-button
                    nzType="text"
                    aria-label="Ver la solicitud sobre el documento"
                    (click)="openComment(record?.recordData)"
                  >
                    <app-icon iconName="messageRegular"></app-icon>
                  </button>
                </div>
              }
              <div class="title">{{ record?.recordData?.documentName }}</div>
              <div class="subtitle">{{ record?.recordData?.documentDetail ?? '' }}</div>

              @if (record?.recordData?.alternatives.length > 1) {
                <ul>
                  @for (alternative of record?.recordData?.alternatives; track $index) {
                    <li class="subtitle">{{ alternative.description }}</li>
                  }
                </ul>
              }
              @if (record?.recordData?.documentUploaded) {
                <!-- El archivo se muestra siempre que esté cargado; el borrado solo cuando el gateway lo permite
                     (un documento ya aprobado se conserva y la fila lo explica en su comentario). -->
                <div class="uploaded-chip">
                  <span class="uploaded-chip__check">
                    <app-icon iconName="checkcircle"></app-icon>
                  </span>
                  <span class="uploaded-chip__name">{{ record?.recordData?.documentFileName }}</span>
                  @if (record?.recordData?.documentCanBeDeleted) {
                    <app-upload-custom-action
                      [action]="cardActions.delete"
                      [recordData]="record.recordData"
                      [recordId]="record.recordId"
                      (actionSelected)="tableActionSelected($event)"
                    >
                      <span class="uploaded-chip__delete">
                        <app-icon iconName="delete"></app-icon>
                      </span>
                    </app-upload-custom-action>
                  }
                </div>
              }
              @if (cardActions.view?.backend && record?.recordData?.documentUploaded) {
                <div style="cursor: pointer">
                  <app-upload-custom-action
                    [action]="cardActions.view"
                    [recordData]="record.recordData"
                    [recordId]="record.recordId"
                    (actionSelected)="tableActionSelected($event)"
                  >
                    <span class="download-link">
                      <app-icon iconName="view"></app-icon>
                      <span>Ver</span>
                    </span>
                  </app-upload-custom-action>
                </div>
              }
              @if (record?.recordData?.documentUploaded && record?.recordData?.documentCanBeDownloaded) {
                <div style="cursor: pointer">
                  <app-upload-custom-action
                    [action]="cardActions.downloadFile"
                    [recordData]="record.recordData"
                    [recordId]="record.recordId"
                    (actionSelected)="tableActionSelected($event)"
                  >
                    <span class="download-link">
                      <app-icon iconName="download"></app-icon>
                      <span>Descargar</span>
                    </span>
                  </app-upload-custom-action>
                </div>
              }

              @if (!record?.recordData?.documentUploaded && record?.recordData?.documentEnabled) {
                <app-upload-action
                  [action]="cardActions.upload"
                  [recordData]="record.recordData"
                  [recordId]="record.recordId"
                  (actionSelected)="tableActionSelected($event)"
                >
                  <app-upload-zone></app-upload-zone>
                </app-upload-action>
              }

              @if (!record?.recordData?.documentUploaded && record?.recordData?.documentFormatUrl) {
                <app-upload-custom-action
                  [action]="cardActions.download"
                  [recordData]="record.recordData"
                  [recordId]="record.recordId"
                  (actionSelected)="tableActionSelected($event)"
                >
                  <span class="download-link">
                    <app-icon iconName="download"></app-icon>
                    <span>Descargar formato</span>
                  </span>
                </app-upload-custom-action>
              }
            </div>
          </div>
        </nz-col>
      }
    </nz-row>
  </div>
}

<!--
  La solicitud del analista («Documento Adicional» en el back-office) admite hasta 1200 caracteres:
  un popover de 15rem no alcanza, así que el mensaje se lee en un modal con desplazamiento propio.
-->
<nz-modal
  [nzVisible]="!!comment()"
  [nzTitle]="comment()?.title"
  [nzContent]="commentContent"
  [nzFooter]="commentFooter"
  [nzWidth]="640"
  nzCentered
  (nzOnCancel)="closeComment()"
>
  <ng-template #commentContent>
    <div class="backendMessageModalText">{{ comment()?.text }}</div>
  </ng-template>
  <ng-template #commentFooter>
    <button nz-button nzType="primary" (click)="closeComment()">Cerrar</button>
  </ng-template>
</nz-modal>
